<script setup>
const menuOpen = ref(false);
const onMenuToggle = () => {
    menuOpen.value = !menuOpen.value;
}
import {useRouter} from "vue-router";
const router = useRouter();
watch(() => router.currentRoute.value.fullPath, () => {
    menuOpen.value = false;
})
</script>

<template>
    <div>
        <Button link icon="pi pi-bars"
                class="lg:hidden layout-menu-button layout-topbar-action !text-white"
                @click="onMenuToggle"
        />

        <Drawer v-model:visible="menuOpen"
                position="left"
                :modal="true"
                :closeOnEscape="true"
                :showHeader="false"
                class="w-64 !bg-gray-700 !border-none mobile-menu"
        >
            <div class="flex flex-col">
                <slot />
            </div>
        </Drawer>
    </div>
</template>

<style lang="scss">
.mobile-menu > .p-button {
    display: flex;
    justify-content: start !important;
}
</style>
